import { safeGET } from "./SafeClient";

interface GAMeasurementIdResponse {
    ga_measurement_id: string;
}

export async function getGAMeasurementId(abort?: any): Promise<string> {
    const response = await safeGET<GAMeasurementIdResponse>("/api/config/ga-measurement-id", abort);
    return response.ga_measurement_id || "";
}

interface GoogleServiceAccountEmailResponse {
    email: string;
}

export async function getGoogleServiceAccountEmail(abort?: any): Promise<string> {
    const response = await safeGET<GoogleServiceAccountEmailResponse>(
        "/api/config/google-service-account-email",
        abort
    );
    return response.email || "";
}
